import React from 'react'
import {FaPhoneAlt} from 'react-icons/fa'

interface PhoneLinkProps {
  phone: string
  className?: string
}

const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digits
  const cleaned = phoneNumber.replace(/\D/g, '')
  // Take last 10 digits if longer
  const numbers = cleaned.slice(-10)
  // Format as (XXX) XXX-XXXX
  const match = numbers.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }
  return phoneNumber
}

const PhoneLink: React.FC<PhoneLinkProps> = ({phone, className}) => {
  const cleanedPhone = phone.replace(/\D/g, '')
  const formattedPhone = formatPhoneNumber(phone)

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation()
  }

  return (
    <a href={`tel:${cleanedPhone}`} onClick={handleClick}>
      <div className={`d-flex align-items-center ${className || ''}`}>
        <FaPhoneAlt className='me-2 text-primary' />
        <span className='m-0 fs-6 text-link'>{formattedPhone}</span>
      </div>
    </a>
  )
}

export default PhoneLink
